import resetField from "./reset-field";

export default function resetButton( fieldElement ) {
  const resultElement = fieldElement.querySelector('.bravo-marknadsinformation-gf__result');
  
  fieldElement.querySelectorAll('[data-marknadsinformation-reset="true"]').forEach(function(resetButton) {
    resetButton.addEventListener('click', function( e ) {
      e.preventDefault();
      e.stopPropagation();
      resetField(fieldElement);
    });
  });
}